import React, { FunctionComponent, PropsWithChildren, useEffect, useRef, useState } from 'react';
import styles from './tooltip-component.module.scss';

type TooltipProps = PropsWithChildren<{
  /**Text to be displasyed in tooltip */
  title: string;
  /** custom tooltip class to style the title attribute */
  className?: string;
}>;

type TooltipState = {
  showTooltip: 0 | 1 | 2; // 0 = hide, 1 = hover, 2 = show
  tooltipX: number;
  tooltipY: number;
};

export const Tooltip: FunctionComponent<TooltipProps> = (props: TooltipProps) => {
  const [state, setState] = useState<TooltipState>({ showTooltip: 0, tooltipX: 0, tooltipY: 0 });
  const throttleTimer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (state.showTooltip === 1)
      throttleTimer.current = setTimeout(() => {
        setState({ ...state, showTooltip: 2 });
      }, 500);
    else if (throttleTimer.current) clearTimeout(throttleTimer.current);

    return () => {
      if (throttleTimer.current) clearTimeout(throttleTimer.current);
    };
  }, [state, state.showTooltip]);

  return (
    <div className={styles['tooltip-elt-container']}>
      <span
        className={`${styles['tooltip-component']} ${props.className ?? ''} ${state.showTooltip !== 2 ? 'hide' : ''}`}
        style={{ '--tooltipX': state.tooltipX + 'px', '--tooltipY': state.tooltipY + 'px' } as React.CSSProperties}
      >
        {props.title}
      </span>
      <span onMouseEnter={(e) => onMouseEnter(e)} onMouseLeave={() => onMouseLeave()}>
        {props.children}
      </span>
    </div>
  );

  function onMouseEnter(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) {
    event.persist();
    if (props.title) {
      const rect = event.currentTarget.getBoundingClientRect();
      const x = event.clientX - rect.left; //x position within the element.
      const y = event.clientY - rect.top; //y position within the element.

      setState({ showTooltip: 1, tooltipX: x, tooltipY: y });
    }
  }

  function onMouseLeave() {
    setState({ ...state, showTooltip: 0 });
  }
};

export default Tooltip;
